// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3JIF4","buttons":"Footer_buttons__2nPN-"};